import { parseISO } from "date-fns";

export interface EventKickoffFields {
  event_date: string;
  kickoff_at?: string | null;
}

/** True when the match has started (admin triggered or scheduled kickoff passed). */
export function isEventPostKickoff(
  event: EventKickoffFields,
  now: Date = new Date()
): boolean {
  if (event.kickoff_at) return true;
  return parseISO(event.event_date) < now;
}

/** Reference time for stale-result / overdue calculations. */
export function eventKickoffTime(event: EventKickoffFields): Date {
  return event.kickoff_at ? parseISO(event.kickoff_at) : parseISO(event.event_date);
}
